import { Id } from "PFTypes";

export const optionsKeys = {
  all: ["selectOptions"],
  dropdown: (dropdownId) => [...optionsKeys.all, dropdownId],
  dropdownWithParams: (dropdownId, searchId: Id = "", ids: Id[] = [], searchTerm = "") => [
    ...optionsKeys.all,
    dropdownId,
    searchId,
    ids,
    searchTerm
  ]
};
